import CreateAndEditCompany from '../CreateAndEditCompany';
import React from 'react';

const EditCompany = () => {
  return <CreateAndEditCompany />;
};

export default EditCompany;
